var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
var __setFunctionName = (this && this.__setFunctionName) || function (f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
import { html, LitElement, nothing } from 'lit';
import { property, query } from 'lit/decorators.js';
import { isEmpty, isNil } from 'lodash-es';
import '../number-input/sds-number-input.lit';
import { translate, translateString } from '../utilities/translate';
import styles from './sds-pagination.lit.scss';
import { sdsCustomElement } from '../utilities/custom-components';
/**
 * Pagination controls for paginated datasets. Requires `total-items` to be configured.
 *
 * @tag sds-pagination
 * @fires {CustomEvent<{currentPage: number, pageSize: number, currentItem: number}>} sds.page.changed - Fired when the user navigates to a different page or when page resets due to a page-size change.
 * @fires {CustomEvent<{currentPage: number, pageSize: number, currentItem: number}>} sds.page.size.changed - Fired when the user selects a different page size. Page resets to 1 before the event fires.
 * @csspart sds-pagination - Root wrapper element.
 * @csspart sds-pagination-not-configured - Placeholder shown when total-items is not set.
 * @csspart sds-pagination-body - Layout row containing the indicator and the navigation controls.
 * @csspart sds-pagination-per-page - Per-page label and select wrapper.
 * @csspart sds-pagination-info - Range info display (e.g. "1 - 10 from 200").
 * @csspart sds-pagination-counter - Page or item counter display (e.g. "1 of 20", "1 of 200").
 * @csspart sds-pagination-controls - Navigation buttons wrapper (first, prev, next, last).
 * @csspart sds-pagination-pages - Page-number links wrapper (with-page-numbers).
 * @csspart sds-pagination-ellipsis - Ellipsis separator between page-number links.
 */
let SdsPagination = (() => {
    var _SdsPagination_mode_accessor_storage, _SdsPagination_totalItems_accessor_storage, _SdsPagination_page_accessor_storage, _SdsPagination_pageSize_accessor_storage, _SdsPagination_pageSizeOptions_accessor_storage, _SdsPagination_indicator_accessor_storage, _SdsPagination_indicatorPosition_accessor_storage, _SdsPagination_navigation_accessor_storage, _SdsPagination_withPageNumbers_accessor_storage, _SdsPagination_withPageSizeSelect_accessor_storage, _SdsPagination_editableIndicator_accessor_storage, _SdsPagination_disabled_accessor_storage, _SdsPagination_size_accessor_storage, _SdsPagination_align_accessor_storage, _SdsPagination__pageSizeSelect_accessor_storage, _SdsPagination__pageInputEl_accessor_storage;
    let _classDecorators = [sdsCustomElement('sds-pagination')];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = LitElement;
    let _mode_decorators;
    let _mode_initializers = [];
    let _mode_extraInitializers = [];
    let _totalItems_decorators;
    let _totalItems_initializers = [];
    let _totalItems_extraInitializers = [];
    let _page_decorators;
    let _page_initializers = [];
    let _page_extraInitializers = [];
    let _pageSize_decorators;
    let _pageSize_initializers = [];
    let _pageSize_extraInitializers = [];
    let _pageSizeOptions_decorators;
    let _pageSizeOptions_initializers = [];
    let _pageSizeOptions_extraInitializers = [];
    let _indicator_decorators;
    let _indicator_initializers = [];
    let _indicator_extraInitializers = [];
    let _indicatorPosition_decorators;
    let _indicatorPosition_initializers = [];
    let _indicatorPosition_extraInitializers = [];
    let _navigation_decorators;
    let _navigation_initializers = [];
    let _navigation_extraInitializers = [];
    let _withPageNumbers_decorators;
    let _withPageNumbers_initializers = [];
    let _withPageNumbers_extraInitializers = [];
    let _withPageSizeSelect_decorators;
    let _withPageSizeSelect_initializers = [];
    let _withPageSizeSelect_extraInitializers = [];
    let _editableIndicator_decorators;
    let _editableIndicator_initializers = [];
    let _editableIndicator_extraInitializers = [];
    let _disabled_decorators;
    let _disabled_initializers = [];
    let _disabled_extraInitializers = [];
    let _size_decorators;
    let _size_initializers = [];
    let _size_extraInitializers = [];
    let _align_decorators;
    let _align_initializers = [];
    let _align_extraInitializers = [];
    let __pageSizeSelect_decorators;
    let __pageSizeSelect_initializers = [];
    let __pageSizeSelect_extraInitializers = [];
    let __pageInputEl_decorators;
    let __pageInputEl_initializers = [];
    let __pageInputEl_extraInitializers = [];
    var SdsPagination = _classThis = class extends _classSuper {
        constructor() {
            super(...arguments);
            _SdsPagination_mode_accessor_storage.set(this, __runInitializers(this, _mode_initializers, 'list'));
            _SdsPagination_totalItems_accessor_storage.set(this, (__runInitializers(this, _mode_extraInitializers), __runInitializers(this, _totalItems_initializers, void 0)));
            _SdsPagination_page_accessor_storage.set(this, (__runInitializers(this, _totalItems_extraInitializers), __runInitializers(this, _page_initializers, 1)));
            _SdsPagination_pageSize_accessor_storage.set(this, (__runInitializers(this, _page_extraInitializers), __runInitializers(this, _pageSize_initializers, 10)));
            _SdsPagination_pageSizeOptions_accessor_storage.set(this, (__runInitializers(this, _pageSize_extraInitializers), __runInitializers(this, _pageSizeOptions_initializers, void 0)));
            _SdsPagination_indicator_accessor_storage.set(this, (__runInitializers(this, _pageSizeOptions_extraInitializers), __runInitializers(this, _indicator_initializers, 'range')));
            _SdsPagination_indicatorPosition_accessor_storage.set(this, (__runInitializers(this, _indicator_extraInitializers), __runInitializers(this, _indicatorPosition_initializers, 'beside')));
            _SdsPagination_navigation_accessor_storage.set(this, (__runInitializers(this, _indicatorPosition_extraInitializers), __runInitializers(this, _navigation_initializers, 'none')));
            _SdsPagination_withPageNumbers_accessor_storage.set(this, (__runInitializers(this, _navigation_extraInitializers), __runInitializers(this, _withPageNumbers_initializers, false)));
            _SdsPagination_withPageSizeSelect_accessor_storage.set(this, (__runInitializers(this, _withPageNumbers_extraInitializers), __runInitializers(this, _withPageSizeSelect_initializers, false)));
            _SdsPagination_editableIndicator_accessor_storage.set(this, (__runInitializers(this, _withPageSizeSelect_extraInitializers), __runInitializers(this, _editableIndicator_initializers, false)));
            _SdsPagination_disabled_accessor_storage.set(this, (__runInitializers(this, _editableIndicator_extraInitializers), __runInitializers(this, _disabled_initializers, false)));
            _SdsPagination_size_accessor_storage.set(this, (__runInitializers(this, _disabled_extraInitializers), __runInitializers(this, _size_initializers, 'lg')));
            _SdsPagination_align_accessor_storage.set(this, (__runInitializers(this, _size_extraInitializers), __runInitializers(this, _align_initializers, 'start')));
            _SdsPagination__pageSizeSelect_accessor_storage.set(this, (__runInitializers(this, _align_extraInitializers), __runInitializers(this, __pageSizeSelect_initializers, void 0)));
            _SdsPagination__pageInputEl_accessor_storage.set(this, (__runInitializers(this, __pageSizeSelect_extraInitializers), __runInitializers(this, __pageInputEl_initializers, void 0)));
            this._numberOfPages = __runInitializers(this, __pageInputEl_extraInitializers);
            /** Set when a page-number link is activated, so focus follows to the new current-page link. */
            this._focusCurrentPageOnUpdate = false;
            /**
             * Set when an arrow is activated, so focus can move to the opposite arrow if the activated
             * one disables itself at a boundary (a disabled control can't hold focus).
             */
            this._focusArrowOnUpdate = null;
        }
        /**
         * The kind of pagination.
         * - `list` (default) — pages through a result set; a step is one page of `page-size` items.
         * - `record` — steps through items one at a time (document/record viewer); `page-size`,
         *   `page-size-options`, and `with-page-size-select` have no effect.
         * @attr {'list' | 'record'} mode
         */
        get mode() { return __classPrivateFieldGet(this, _SdsPagination_mode_accessor_storage, "f"); }
        set mode(value) { __classPrivateFieldSet(this, _SdsPagination_mode_accessor_storage, value, "f"); }
        /** Total number of items to paginate through. @attr {number} total-items */
        get totalItems() { return __classPrivateFieldGet(this, _SdsPagination_totalItems_accessor_storage, "f"); }
        set totalItems(value) { __classPrivateFieldSet(this, _SdsPagination_totalItems_accessor_storage, value, "f"); }
        /** Current page (1-based). In `record` mode this is the current item index. @attr {number} page */
        get page() { return __classPrivateFieldGet(this, _SdsPagination_page_accessor_storage, "f"); }
        set page(value) { __classPrivateFieldSet(this, _SdsPagination_page_accessor_storage, value, "f"); }
        /** Number of items displayed per page. Ignored in `record` mode. @attr {number} page-size */
        get pageSize() { return __classPrivateFieldGet(this, _SdsPagination_pageSize_accessor_storage, "f"); }
        set pageSize(value) { __classPrivateFieldSet(this, _SdsPagination_pageSize_accessor_storage, value, "f"); }
        /**
         * Selectable page-size options shown in the per-page select dropdown. Auto-calculated from
         * `total-items` when omitted. Ignored in `record` mode. @attr {number[]} page-size-options
         */
        get pageSizeOptions() { return __classPrivateFieldGet(this, _SdsPagination_pageSizeOptions_accessor_storage, "f"); }
        set pageSizeOptions(value) { __classPrivateFieldSet(this, _SdsPagination_pageSizeOptions_accessor_storage, value, "f"); }
        /**
         * The position indicator shown alongside the controls.
         * - `range` (default) — a range readout ("1 - 10 from 200").
         * - `counter` — a counter readout ("1 of 20" in list mode, "1 of 200" in record mode).
         * - `none` — no indicator.
         *
         * `range` is not meaningful in `record` mode and falls back to `counter`.
         * @attr {'none' | 'range' | 'counter'} indicator
         */
        get indicator() { return __classPrivateFieldGet(this, _SdsPagination_indicator_accessor_storage, "f"); }
        set indicator(value) { __classPrivateFieldSet(this, _SdsPagination_indicator_accessor_storage, value, "f"); }
        /**
         * Where the indicator renders relative to the navigation buttons.
         * - `beside` (default) — in its own slot next to the buttons.
         * - `between` — between the prev and next buttons.
         *
         * Always `between` in `record` mode. Ignored when `navigation` is `none` (the indicator
         * renders on its own).
         * @attr {'beside' | 'between'} indicator-position
         */
        get indicatorPosition() { return __classPrivateFieldGet(this, _SdsPagination_indicatorPosition_accessor_storage, "f"); }
        set indicatorPosition(value) { __classPrivateFieldSet(this, _SdsPagination_indicatorPosition_accessor_storage, value, "f"); }
        /**
         * Navigation arrow buttons.
         * - `none` (default) — no arrows.
         * - `simple` — prev and next only.
         * - `full` — first, prev, next, last.
         * @attr {'none' | 'simple' | 'full'} navigation
         */
        get navigation() { return __classPrivateFieldGet(this, _SdsPagination_navigation_accessor_storage, "f"); }
        set navigation(value) { __classPrivateFieldSet(this, _SdsPagination_navigation_accessor_storage, value, "f"); }
        /**
         * Shows composable page-number links (with ellipses) between the navigation arrows.
         * Composes with any `navigation` value, e.g. `navigation="simple"` → `< 1 2 3 … 10 >`.
         * The page links convey position themselves, so `indicator` is not rendered when set.
         * @attr {boolean} with-page-numbers
         */
        get withPageNumbers() { return __classPrivateFieldGet(this, _SdsPagination_withPageNumbers_accessor_storage, "f"); }
        set withPageNumbers(value) { __classPrivateFieldSet(this, _SdsPagination_withPageNumbers_accessor_storage, value, "f"); }
        /** Shows the per-page select dropdown. Ignored in `record` mode. @attr {boolean} with-page-size-select */
        get withPageSizeSelect() { return __classPrivateFieldGet(this, _SdsPagination_withPageSizeSelect_accessor_storage, "f"); }
        set withPageSizeSelect(value) { __classPrivateFieldSet(this, _SdsPagination_withPageSizeSelect_accessor_storage, value, "f"); }
        /**
         * Replaces the indicator's page number with an editable input.
         * Navigates to the typed page on Enter or blur and dispatches `sds.page.changed`.
         * @attr {boolean} editable-indicator
         */
        get editableIndicator() { return __classPrivateFieldGet(this, _SdsPagination_editableIndicator_accessor_storage, "f"); }
        set editableIndicator(value) { __classPrivateFieldSet(this, _SdsPagination_editableIndicator_accessor_storage, value, "f"); }
        /** Disables all interactive controls when set. @attr {boolean} disabled */
        get disabled() { return __classPrivateFieldGet(this, _SdsPagination_disabled_accessor_storage, "f"); }
        set disabled(value) { __classPrivateFieldSet(this, _SdsPagination_disabled_accessor_storage, value, "f"); }
        /**
         * Size of the pagination controls.
         * - `lg` (default) — buttons use `md` size
         * - `sm` — buttons use `sm` size and padding is reduced
         * @attr {'lg' | 'sm'} size
         */
        get size() { return __classPrivateFieldGet(this, _SdsPagination_size_accessor_storage, "f"); }
        set size(value) { __classPrivateFieldSet(this, _SdsPagination_size_accessor_storage, value, "f"); }
        /**
         * Horizontal alignment within the container. `center`/`end` make the host span the full
         * width and justify the content; `start` keeps the default (content-width, leading edge).
         * Uses logical values, so `end` is the right edge in LTR and the left edge in RTL.
         * @attr {'start' | 'center' | 'end'} align
         */
        get align() { return __classPrivateFieldGet(this, _SdsPagination_align_accessor_storage, "f"); }
        set align(value) { __classPrivateFieldSet(this, _SdsPagination_align_accessor_storage, value, "f"); }
        get _pageSizeSelect() { return __classPrivateFieldGet(this, _SdsPagination__pageSizeSelect_accessor_storage, "f"); }
        set _pageSizeSelect(value) { __classPrivateFieldSet(this, _SdsPagination__pageSizeSelect_accessor_storage, value, "f"); }
        get _pageInputEl() { return __classPrivateFieldGet(this, _SdsPagination__pageInputEl_accessor_storage, "f"); }
        set _pageInputEl(value) { __classPrivateFieldSet(this, _SdsPagination__pageInputEl_accessor_storage, value, "f"); }
        get _isRecordMode() {
            return this.mode === 'record';
        }
        /** Range info is meaningless for single-item stepping, so record mode coerces it to a counter. */
        get _effectiveIndicator() {
            if (this._isRecordMode && this.indicator === 'range') {
                return 'counter';
            }
            return this.indicator;
        }
        get _hasControls() {
            return this.navigation !== 'none' || this.withPageNumbers;
        }
        /** Page-number links already convey position, so no separate indicator is shown alongside them. */
        get _indicatorSuppressed() {
            return this.withPageNumbers;
        }
        /** Indicator sits between the prev/next buttons (explicit between, or always in record mode). */
        get _indicatorInline() {
            if (this._indicatorSuppressed) {
                return false;
            }
            return (this._effectiveIndicator !== 'none' &&
                this._hasControls &&
                (this.indicatorPosition === 'between' || this._isRecordMode));
        }
        /** Indicator sits outside the controls: explicit aside, or standalone when there are no buttons. */
        get _indicatorAside() {
            if (this._indicatorSuppressed) {
                return false;
            }
            return this._effectiveIndicator !== 'none' && !this._indicatorInline;
        }
        /**
         * Uniform position text for the visually-hidden live region, announced on every navigation
         * regardless of which indicator (if any) is visible — e.g. "Page 6 of 20" / "Item 6 of 200".
         */
        get _positionAnnouncement() {
            const total = this._isRecordMode ? this.totalItems : this._numberOfPages;
            const unit = this._isRecordMode ? translateString('sds.item') : translateString('sds.page');
            return `${unit} ${this.page} ${translateString('sds.of')} ${total}`;
        }
        firstUpdated(changedProperties) {
            super.firstUpdated(changedProperties);
            if (!isNil(this.pageSizeOptions) &&
                !isEmpty(this.pageSizeOptions) &&
                !this.pageSizeOptions.includes(this.pageSize)) {
                this.pageSize = this.pageSizeOptions[0];
            }
        }
        willUpdate(_changedProperties) {
            var _a;
            super.willUpdate(_changedProperties);
            if (!isNil(this.pageSize) && this.pageSize <= 0) {
                this.pageSize = 10;
            }
            if (_changedProperties.has('pageSize') &&
                _changedProperties.get('pageSize') !== undefined) {
                this.pageSizeChanged();
            }
            if (!isNil(this.totalItems) && this.pageSize > 0) {
                const maxPage = this._isRecordMode
                    ? this.totalItems
                    : Math.floor(this.totalItems / this.pageSize) +
                        (this.totalItems % this.pageSize === 0 ? 0 : 1);
                if (this.page < 1)
                    this.page = 1;
                else if (maxPage > 0 && this.page > maxPage)
                    this.page = maxPage;
            }
            this.initCalculations();
            (_a = this._pageSizeSelect) === null || _a === void 0 ? void 0 : _a.requestUpdate();
        }
        initCalculations() {
            this.countNumberOfPages();
            this.countFirstItemIndex();
            this.countLastItemIndex();
            this.storePageSizeOptions();
        }
        updated(changedProperties) {
            var _a, _b, _c, _d, _e, _f;
            super.updated(changedProperties);
            if (this._focusCurrentPageOnUpdate) {
                this._focusCurrentPageOnUpdate = false;
                (_b = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('.sds-pagination__page-button[aria-current="page"]')) === null || _b === void 0 ? void 0 : _b.focus();
            }
            if (this._focusArrowOnUpdate) {
                const direction = this._focusArrowOnUpdate;
                this._focusArrowOnUpdate = null;
                // An arrow that disables itself at a boundary can't keep focus, so move focus to
                // the opposite (still-enabled) arrow. If the activated arrow is still enabled,
                // focus stays on it naturally and we do nothing.
                if (direction === 'backward' && !this.canNavigatePrevious()) {
                    (_d = (_c = this.shadowRoot) === null || _c === void 0 ? void 0 : _c.querySelector('.sds-pagination__next')) === null || _d === void 0 ? void 0 : _d.focus();
                }
                else if (direction === 'forward' && !this.canNavigateNext()) {
                    (_f = (_e = this.shadowRoot) === null || _e === void 0 ? void 0 : _e.querySelector('.sds-pagination__prev')) === null || _f === void 0 ? void 0 : _f.focus();
                }
            }
        }
        render() {
            if (isNil(this.totalItems)) {
                return html `
                <div
                    class="sds-pagination sds-pagination--not-configured"
                    part="sds-pagination-not-configured"
                    role="status"
                >
                    ${translate('sds.not-configured')}
                </div>
            `;
            }
            return html `
            <div class="sds-pagination" part="sds-pagination">
                <span class="sds-pagination__live-region sr-only" role="status">
                    ${this._positionAnnouncement}
                </span>
                ${this.renderPerPageSelect()}
                <div class="sds-pagination__body" part="sds-pagination-body">
                    ${this._indicatorAside ? this.renderIndicator() : ''}
                    ${this._hasControls ? this.renderControls() : ''}
                </div>
            </div>
        `;
        }
        addEventListener(type, listener, options) {
            super.addEventListener(type, listener, options);
        }
        countNumberOfPages() {
            if (!isNil(this.totalItems)) {
                this._numberOfPages = this._isRecordMode
                    ? this.totalItems
                    : Math.floor(this.totalItems / this.pageSize) +
                        (this.totalItems % this.pageSize === 0 ? 0 : 1);
            }
            else {
                this._numberOfPages = Number.MAX_SAFE_INTEGER;
            }
        }
        countFirstItemIndex() {
            if (!isNil(this.totalItems) && this.totalItems !== 0) {
                this._firstItemIndex = this.pageSize * (this.page - 1) + 1;
            }
            else {
                this._firstItemIndex = 0;
            }
        }
        countLastItemIndex() {
            if (!isNil(this.totalItems) && this.totalItems !== 0) {
                if (this.page !== this._numberOfPages) {
                    this._lastItemIndex = this.pageSize * this.page;
                }
                else {
                    this._lastItemIndex = this.totalItems;
                }
            }
            else {
                this._lastItemIndex = 0;
            }
        }
        storePageSizeOptions() {
            if (!isNil(this.pageSizeOptions) && !isEmpty(this.pageSizeOptions)) {
                this._resolvedPageSizeOptions = this.pageSizeOptions;
                return;
            }
            if (!isNil(this.totalItems)) {
                if (this.totalItems > 50) {
                    this._resolvedPageSizeOptions = [10, 20, 50, 100];
                }
                else if (this.totalItems > 20) {
                    this._resolvedPageSizeOptions = [10, 20, 50];
                }
                else if (this.totalItems > 10) {
                    this._resolvedPageSizeOptions = [10, 20];
                }
                else {
                    this._resolvedPageSizeOptions = [10];
                }
            }
            else {
                this._resolvedPageSizeOptions = [10];
            }
        }
        get _buttonSize() {
            return this.size === 'sm' ? 'sm' : 'md';
        }
        get _currentItem() {
            return this._isRecordMode ? this.page : this._firstItemIndex;
        }
        canNavigateNext() {
            if (this._isRecordMode) {
                return this.totalItems > 1 && this.page !== this._numberOfPages;
            }
            return this.totalItems > this.pageSize && this.page !== this._numberOfPages;
        }
        canNavigatePrevious() {
            return this.page > 1;
        }
        goToTheLastPage() {
            this._focusArrowOnUpdate = 'forward';
            this.goToThePage(this._numberOfPages);
        }
        goToTheFirstPage() {
            this._focusArrowOnUpdate = 'backward';
            this.goToThePage(1);
        }
        goToThePage(index) {
            if (index > 0 && index <= this._numberOfPages && this.page !== index) {
                this.page = index;
                this.handleChanged();
            }
        }
        /**
         * Navigates from a page-number link. The link set re-renders around the new current page,
         * so without moving focus it would land on whatever button now occupies the old DOM
         * position. Flag the navigation so `updated()` re-focuses the new current-page link.
         */
        handlePageLinkClick(index) {
            if (index !== this.page) {
                this._focusCurrentPageOnUpdate = true;
            }
            this.goToThePage(index);
        }
        goToTheNextPage() {
            this._focusArrowOnUpdate = 'forward';
            this.goToThePage(this.page + 1);
        }
        goToThePreviousPage() {
            this._focusArrowOnUpdate = 'backward';
            this.goToThePage(this.page - 1);
        }
        pageSizeChangedHandler(identifier) {
            this.pageSize = Number(identifier);
        }
        pageSizeChanged() {
            this.countNumberOfPages();
            this.page = 1;
            this.dispatchEvent(new CustomEvent(SdsPagination.CHANGE_PAGE_SIZE_EVENT, {
                detail: {
                    currentPage: this.page,
                    pageSize: this.pageSize,
                    currentItem: this._currentItem,
                },
                bubbles: true,
                composed: true,
            }));
            this.handleChanged();
        }
        handleChanged() {
            const changed = new CustomEvent(SdsPagination.CHANGE_EVENT, {
                detail: {
                    currentPage: this.page,
                    pageSize: this.pageSize,
                    currentItem: this._currentItem,
                },
                bubbles: true,
                composed: true,
            });
            this.dispatchEvent(changed);
        }
        renderPerPageSelect() {
            if (this.withPageSizeSelect && !this._isRecordMode) {
                return html `
                <div class="sds-pagination__per-page" part="sds-pagination-per-page">
                    <sds-form-control
                        label="${translateString('common.items-per-page.label')}"
                        horizontal
                    >
                        <sds-select
                            id="page-size-select"
                            simple
                            value="${this.pageSize}"
                            @sds.select.selected="${(event) => this.pageSizeChangedHandler(event.detail.identifier)}"
                            ?disabled="${this.disabled ||
                    this.totalItems <= this._resolvedPageSizeOptions[0]}"
                            pagination
                        >
                            ${this._resolvedPageSizeOptions.map(element => html `<sds-cm-select-item
                                        name="${element}"
                                        identifier="${element}"
                                    ></sds-cm-select-item>`)}
                        </sds-select>
                    </sds-form-control>
                </div>
            `;
            }
        }
        renderControls() {
            return html `
            <nav
                class="sds-pagination__controls"
                part="sds-pagination-controls"
                aria-label="${translateString('sds.pagination')}"
            >
                ${this.renderGoToFirstButton()} ${this.renderGoToPreviousButton()}
                ${this.withPageNumbers
                ? this.renderPageLinks()
                : this._indicatorInline
                    ? this.renderIndicator()
                    : ''}
                ${this.renderGoToNextButton()} ${this.renderGoToLastButton()}
            </nav>
        `;
        }
        /**
         * Builds the page-link sequence for `with-page-numbers`: the first and last pages, a
         * window around the current page, and `'ellipsis'` markers bridging the gaps. Mirrors the
         * widely-used boundary/sibling algorithm so the output stays compact for large page counts.
         */
        getPageItems() {
            const total = this._numberOfPages;
            const current = this.page;
            const boundaryCount = 1; // pages always shown at each edge
            const siblingCount = 1; // pages shown on each side of the current page
            const range = (start, end) => Array.from({ length: Math.max(end - start + 1, 0) }, (_, i) => start + i);
            // Few enough pages to show them all without ellipses.
            const totalSlots = boundaryCount * 2 + siblingCount * 2 + 3;
            if (total <= totalSlots) {
                return range(1, total);
            }
            const startPages = range(1, boundaryCount);
            const endPages = range(total - boundaryCount + 1, total);
            const siblingsStart = Math.max(Math.min(current - siblingCount, total - boundaryCount - siblingCount * 2 - 1), boundaryCount + 2);
            const siblingsEnd = Math.min(Math.max(current + siblingCount, boundaryCount + siblingCount * 2 + 2), endPages[0] - 2);
            return [
                ...startPages,
                ...(siblingsStart > boundaryCount + 2
                    ? ['ellipsis']
                    : boundaryCount + 1 < total - boundaryCount
                        ? [boundaryCount + 1]
                        : []),
                ...range(siblingsStart, siblingsEnd),
                ...(siblingsEnd < total - boundaryCount - 1
                    ? ['ellipsis']
                    : total - boundaryCount > boundaryCount
                        ? [total - boundaryCount]
                        : []),
                ...endPages,
            ];
        }
        renderPageLinks() {
            return html `
            <ol class="sds-pagination__pages" part="sds-pagination-pages">
                ${this.getPageItems().map(item => item === 'ellipsis'
                ? html `<li
                              class="sds-pagination__ellipsis"
                              part="sds-pagination-ellipsis"
                              aria-hidden="true"
                          >
                              …
                          </li>`
                : html `
                              <li class="sds-pagination__page">
                                  <sds-button
                                      class="sds-pagination__page-button"
                                      library="system"
                                      type="custom"
                                      data-aria-label="${this.pageAriaLabel(item)}"
                                      aria-current="${item === this.page ? 'page' : nothing}"
                                      ?selected="${item === this.page}"
                                      ?disabled="${this.disabled}"
                                      @click="${() => this.handlePageLinkClick(item)}"
                                      >${item}</sds-button
                                  >
                              </li>
                          `)}
            </ol>
        `;
        }
        /**
         * Builds the accessible name for a page link, e.g. "Page 5". The current page is conveyed
         * by `aria-current="page"` on the button, so it isn't repeated in the name.
         */
        pageAriaLabel(pageNumber) {
            return `${translateString('sds.page')} ${pageNumber}`;
        }
        renderIndicator() {
            if (this._effectiveIndicator === 'range') {
                return this.renderInfo();
            }
            if (this._effectiveIndicator === 'counter') {
                return this.renderCounter();
            }
            return '';
        }
        renderInfo() {
            if (this.totalItems === 0) {
                return html `
                <div class="sds-pagination__info" part="sds-pagination-info">
                    <span>0</span>
                    <bdi>${translate('sds.from')}</bdi>
                    0
                </div>
            `;
            }
            return html `
            <div class="sds-pagination__info" part="sds-pagination-info">
                <span>${this._firstItemIndex} - ${this._lastItemIndex} </span>
                <bdi>${translate('sds.from')}</bdi>
                ${this.totalItems}
            </div>
        `;
        }
        renderCounter() {
            const totalCount = this._isRecordMode ? this.totalItems : this._numberOfPages;
            return html `
            <div class="sds-pagination__page-counter" part="sds-pagination-counter">
                ${this.editableIndicator ? this.renderPageInput() : this.page}
                <bdi>${translate('sds.of')}</bdi> ${totalCount}
            </div>
        `;
        }
        renderPageInput() {
            const digits = String(this._numberOfPages).length;
            const inputWidth = Math.max(40, digits * 10 + 11);
            return html `
            <sds-number-input
                class="sds-pagination__page-input"
                style="--sds-page-input-width: ${inputWidth}px"
                .value="${String(this.page)}"
                min="1"
                max="${this._numberOfPages}"
                max-digit-count="${digits}"
                integer-only
                ?disabled="${this.disabled}"
                @sds.input.changed="${(e) => this.handlePageInputChange(e.detail.value)}"
                @keydown="${(e) => {
                if (e.key === 'Enter')
                    e.currentTarget.blur();
            }}"
            ></sds-number-input>
        `;
        }
        handlePageInputChange(value) {
            if (value === '' || isNaN(value)) {
                if (this._pageInputEl) {
                    this._pageInputEl.value = String(this.page);
                }
                return;
            }
            this.goToThePage(Math.min(Math.max(Math.round(value), 1), this._numberOfPages));
        }
        /** Picks the page- or item-oriented translation key for navigation labels based on mode. */
        _navLabel(pageKey, itemKey) {
            return translateString(this._isRecordMode ? itemKey : pageKey);
        }
        renderGoToFirstButton() {
            if (this.navigation === 'full') {
                return html `
                <sds-button
                    class="sds-pagination__first"
                    library="system"
                    type="ghost"
                    icon="arrow_go_to_start_thin"
                    size="${this._buttonSize}"
                    primary
                    tooltip="${this._navLabel('sds.first-page', 'sds.first-item')}"
                    ?disabled="${this.disabled || !this.canNavigatePrevious()}"
                    @click="${() => this.goToTheFirstPage()}"
                ></sds-button>
            `;
            }
        }
        renderGoToPreviousButton() {
            if (this.navigation === 'none') {
                return;
            }
            return html `
            <sds-button
                class="sds-pagination__prev"
                library="system"
                type="ghost"
                icon="arrow_left_thin"
                size="${this._buttonSize}"
                primary
                tooltip="${this._navLabel('sds.previous-page', 'sds.previous-item')}"
                ?disabled="${this.disabled || !this.canNavigatePrevious()}"
                @click="${() => this.goToThePreviousPage()}"
            ></sds-button>
        `;
        }
        renderGoToNextButton() {
            if (this.navigation === 'none') {
                return;
            }
            return html `
            <sds-button
                class="sds-pagination__next"
                library="system"
                type="ghost"
                icon="arrow_right_thin"
                size="${this._buttonSize}"
                primary
                tooltip="${this._navLabel('sds.next-page', 'sds.next-item')}"
                ?disabled="${this.disabled || !this.canNavigateNext()}"
                @click="${() => this.goToTheNextPage()}"
            ></sds-button>
        `;
        }
        renderGoToLastButton() {
            if (this.navigation === 'full') {
                return html `
                <sds-button
                    class="sds-pagination__last"
                    library="system"
                    type="ghost"
                    icon="arrow_go_to_end_thin"
                    size="${this._buttonSize}"
                    primary
                    tooltip="${this._navLabel('sds.last-page', 'sds.last-item')}"
                    ?disabled="${this.disabled || !this.canNavigateNext()}"
                    @click="${() => this.goToTheLastPage()}"
                ></sds-button>
            `;
            }
        }
    };
    _SdsPagination_mode_accessor_storage = new WeakMap();
    _SdsPagination_totalItems_accessor_storage = new WeakMap();
    _SdsPagination_page_accessor_storage = new WeakMap();
    _SdsPagination_pageSize_accessor_storage = new WeakMap();
    _SdsPagination_pageSizeOptions_accessor_storage = new WeakMap();
    _SdsPagination_indicator_accessor_storage = new WeakMap();
    _SdsPagination_indicatorPosition_accessor_storage = new WeakMap();
    _SdsPagination_navigation_accessor_storage = new WeakMap();
    _SdsPagination_withPageNumbers_accessor_storage = new WeakMap();
    _SdsPagination_withPageSizeSelect_accessor_storage = new WeakMap();
    _SdsPagination_editableIndicator_accessor_storage = new WeakMap();
    _SdsPagination_disabled_accessor_storage = new WeakMap();
    _SdsPagination_size_accessor_storage = new WeakMap();
    _SdsPagination_align_accessor_storage = new WeakMap();
    _SdsPagination__pageSizeSelect_accessor_storage = new WeakMap();
    _SdsPagination__pageInputEl_accessor_storage = new WeakMap();
    __setFunctionName(_classThis, "SdsPagination");
    (() => {
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _mode_decorators = [property({ type: String, reflect: true })];
        _totalItems_decorators = [property({ type: Number, attribute: 'total-items' })];
        _page_decorators = [property({ type: Number, attribute: 'page', reflect: true })];
        _pageSize_decorators = [property({ type: Number, attribute: 'page-size', reflect: true })];
        _pageSizeOptions_decorators = [property({ type: (Array), attribute: 'page-size-options' })];
        _indicator_decorators = [property({ type: String })];
        _indicatorPosition_decorators = [property({ type: String, attribute: 'indicator-position' })];
        _navigation_decorators = [property({ type: String })];
        _withPageNumbers_decorators = [property({ type: Boolean, attribute: 'with-page-numbers', reflect: true })];
        _withPageSizeSelect_decorators = [property({ type: Boolean, attribute: 'with-page-size-select' })];
        _editableIndicator_decorators = [property({ type: Boolean, attribute: 'editable-indicator' })];
        _disabled_decorators = [property({ type: Boolean, reflect: true })];
        _size_decorators = [property({ type: String, reflect: true })];
        _align_decorators = [property({ type: String, reflect: true })];
        __pageSizeSelect_decorators = [query('#page-size-select')];
        __pageInputEl_decorators = [query('sds-number-input.sds-pagination__page-input')];
        __esDecorate(_classThis, null, _mode_decorators, { kind: "accessor", name: "mode", static: false, private: false, access: { has: obj => "mode" in obj, get: obj => obj.mode, set: (obj, value) => { obj.mode = value; } }, metadata: _metadata }, _mode_initializers, _mode_extraInitializers);
        __esDecorate(_classThis, null, _totalItems_decorators, { kind: "accessor", name: "totalItems", static: false, private: false, access: { has: obj => "totalItems" in obj, get: obj => obj.totalItems, set: (obj, value) => { obj.totalItems = value; } }, metadata: _metadata }, _totalItems_initializers, _totalItems_extraInitializers);
        __esDecorate(_classThis, null, _page_decorators, { kind: "accessor", name: "page", static: false, private: false, access: { has: obj => "page" in obj, get: obj => obj.page, set: (obj, value) => { obj.page = value; } }, metadata: _metadata }, _page_initializers, _page_extraInitializers);
        __esDecorate(_classThis, null, _pageSize_decorators, { kind: "accessor", name: "pageSize", static: false, private: false, access: { has: obj => "pageSize" in obj, get: obj => obj.pageSize, set: (obj, value) => { obj.pageSize = value; } }, metadata: _metadata }, _pageSize_initializers, _pageSize_extraInitializers);
        __esDecorate(_classThis, null, _pageSizeOptions_decorators, { kind: "accessor", name: "pageSizeOptions", static: false, private: false, access: { has: obj => "pageSizeOptions" in obj, get: obj => obj.pageSizeOptions, set: (obj, value) => { obj.pageSizeOptions = value; } }, metadata: _metadata }, _pageSizeOptions_initializers, _pageSizeOptions_extraInitializers);
        __esDecorate(_classThis, null, _indicator_decorators, { kind: "accessor", name: "indicator", static: false, private: false, access: { has: obj => "indicator" in obj, get: obj => obj.indicator, set: (obj, value) => { obj.indicator = value; } }, metadata: _metadata }, _indicator_initializers, _indicator_extraInitializers);
        __esDecorate(_classThis, null, _indicatorPosition_decorators, { kind: "accessor", name: "indicatorPosition", static: false, private: false, access: { has: obj => "indicatorPosition" in obj, get: obj => obj.indicatorPosition, set: (obj, value) => { obj.indicatorPosition = value; } }, metadata: _metadata }, _indicatorPosition_initializers, _indicatorPosition_extraInitializers);
        __esDecorate(_classThis, null, _navigation_decorators, { kind: "accessor", name: "navigation", static: false, private: false, access: { has: obj => "navigation" in obj, get: obj => obj.navigation, set: (obj, value) => { obj.navigation = value; } }, metadata: _metadata }, _navigation_initializers, _navigation_extraInitializers);
        __esDecorate(_classThis, null, _withPageNumbers_decorators, { kind: "accessor", name: "withPageNumbers", static: false, private: false, access: { has: obj => "withPageNumbers" in obj, get: obj => obj.withPageNumbers, set: (obj, value) => { obj.withPageNumbers = value; } }, metadata: _metadata }, _withPageNumbers_initializers, _withPageNumbers_extraInitializers);
        __esDecorate(_classThis, null, _withPageSizeSelect_decorators, { kind: "accessor", name: "withPageSizeSelect", static: false, private: false, access: { has: obj => "withPageSizeSelect" in obj, get: obj => obj.withPageSizeSelect, set: (obj, value) => { obj.withPageSizeSelect = value; } }, metadata: _metadata }, _withPageSizeSelect_initializers, _withPageSizeSelect_extraInitializers);
        __esDecorate(_classThis, null, _editableIndicator_decorators, { kind: "accessor", name: "editableIndicator", static: false, private: false, access: { has: obj => "editableIndicator" in obj, get: obj => obj.editableIndicator, set: (obj, value) => { obj.editableIndicator = value; } }, metadata: _metadata }, _editableIndicator_initializers, _editableIndicator_extraInitializers);
        __esDecorate(_classThis, null, _disabled_decorators, { kind: "accessor", name: "disabled", static: false, private: false, access: { has: obj => "disabled" in obj, get: obj => obj.disabled, set: (obj, value) => { obj.disabled = value; } }, metadata: _metadata }, _disabled_initializers, _disabled_extraInitializers);
        __esDecorate(_classThis, null, _size_decorators, { kind: "accessor", name: "size", static: false, private: false, access: { has: obj => "size" in obj, get: obj => obj.size, set: (obj, value) => { obj.size = value; } }, metadata: _metadata }, _size_initializers, _size_extraInitializers);
        __esDecorate(_classThis, null, _align_decorators, { kind: "accessor", name: "align", static: false, private: false, access: { has: obj => "align" in obj, get: obj => obj.align, set: (obj, value) => { obj.align = value; } }, metadata: _metadata }, _align_initializers, _align_extraInitializers);
        __esDecorate(_classThis, null, __pageSizeSelect_decorators, { kind: "accessor", name: "_pageSizeSelect", static: false, private: false, access: { has: obj => "_pageSizeSelect" in obj, get: obj => obj._pageSizeSelect, set: (obj, value) => { obj._pageSizeSelect = value; } }, metadata: _metadata }, __pageSizeSelect_initializers, __pageSizeSelect_extraInitializers);
        __esDecorate(_classThis, null, __pageInputEl_decorators, { kind: "accessor", name: "_pageInputEl", static: false, private: false, access: { has: obj => "_pageInputEl" in obj, get: obj => obj._pageInputEl, set: (obj, value) => { obj._pageInputEl = value; } }, metadata: _metadata }, __pageInputEl_initializers, __pageInputEl_extraInitializers);
        __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
        SdsPagination = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
    })();
    _classThis.CHANGE_EVENT = 'sds.page.changed';
    _classThis.CHANGE_PAGE_SIZE_EVENT = 'sds.page.size.changed';
    _classThis.styles = styles;
    (() => {
        __runInitializers(_classThis, _classExtraInitializers);
    })();
    return SdsPagination = _classThis;
})();
export { SdsPagination };
